import SearchBar from '@/components/atoms/SearchBar/SearchBar';

interface FilterSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

export const FilterSearchField = ({ value, onChange, placeholder }: FilterSearchFieldProps) => (
  <div className="sticky top-0 z-10 bg-background pt-1.5 pb-1">
    <SearchBar
      size="sm"
      className="w-full"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={placeholder}
    />
  </div>
);
